import React from 'react';
import { Button } from '../../../components/base/Button';

export const AboutSection: React.FC = () => {
  const stats = [
    { number: '500+', label: 'Successful Exits' },
    { number: '15+', label: 'Years Experience' },
    { number: '98%', label: 'Client Satisfaction' },
    { number: '$50M+', label: 'Value Recovered' }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
              Why Choose Vacation Developer?
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              With over a decade of experience in our team with the timeshare and resort industry, 
              we've helped hundreds of clients navigate complex property situations 
              and achieve their investment goals.
            </p>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-shield-check-line text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Transparent Process</h3>
                  <p className="text-gray-600">No hidden fees or surprise costs. We provide clear, upfront pricing and keep you informed every step of the way.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-user-heart-line text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Client-Centric Approach</h3>
                  <p className="text-gray-600">Your success is our priority. We tailor our services to meet your specific needs and investment goals.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-award-line text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Expert Team</h3>
                  <p className="text-gray-600">Our certified professionals have extensive knowledge in real estate law, contract negotiation, and market analysis.</p>
                </div>
              </div>
            </div>
            
            <Button onClick={scrollToContact} size="lg">
              <i className="ri-team-line mr-2"></i>
              Meet Our Team
            </Button>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/3da85e239a2fdc21e58ead640b44416b.jpg"
              alt="Our Expert Team"
              className="rounded-2xl shadow-2xl object-cover object-top w-full h-96"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
